import { useEffect } from 'react';
import { useLanguage } from '@/context/LanguageContext';

const SITE_URL = 'https://dzentlimited.com';

const seoData = {
  '/': {
    'zh-TW': {
      title: '埵智有限公司 DZent Limited | 合約風險掃描與管理 AI（LC Shield、Vowpace AI）',
      description: '埵智有限公司是一間香港公司，打造合約與貿易單據風險核對 AI 工具：LC Shield（UCP 600 / ISBP 821 預先核對）與 Vowpace AI。',
      keywords: '埵智,DZent,合約風險,AI 審核,Vowpace AI,LC Shield,UCP 600,建築合約,信用證,香港',
    },
    'zh-CN': {
      title: '埵智有限公司 DZent Limited | 合同风险扫描与管理 AI（LC Shield、Vowpace AI）',
      description: '埵智有限公司是一间香港公司，打造合同与贸易单据风险核对 AI 工具：LC Shield（UCP 600 / ISBP 821 预先核对）与 Vowpace AI。',
      keywords: '埵智,DZent,合同风险,AI 审核,Vowpace AI,LC Shield,UCP 600,建筑合同,信用证,香港',
    },
    en: {
      title: 'DZent Limited | Contract Risk Scanning & Management AI (LC Shield, Vowpace AI)',
      description: 'DZent Limited is a Hong Kong company building AI tools for contract and trade-document risk checking: LC Shield (UCP 600 / ISBP 821 pre-check) and Vowpace AI.',
      keywords: 'DZent,contract risk,AI audit,Vowpace AI,LC Shield,UCP 600,construction contracts,letter of credit,Hong Kong',
    },
  },
  '/about': {
    'zh-TW': {
      title: '關於我們 | 埵智有限公司 DZent Limited',
      description: '了解埵智有限公司 — 專注合約風險掃描與管理的香港垂直 AI 企業。認識我們的專長、公司歷程與私隱優先架構。',
      keywords: '埵智,DZent,關於我們,公司願景,使命,團隊,香港科技公司',
    },
    'zh-CN': {
      title: '关于我们 | 埵智有限公司 DZent Limited',
      description: '了解埵智有限公司 — 专注合同风险扫描与管理的香港垂直 AI 企业。认识我们的专长、公司历程与隐私优先架构。',
      keywords: '埵智,DZent,关于我们,公司愿景,使命,团队,香港科技公司',
    },
    en: {
      title: 'About Us | DZent Limited',
      description: 'Learn about DZent Limited — a Hong Kong vertical AI enterprise dedicated to contract risk scanning and management. Discover our expertise, journey, and privacy-first architecture.',
      keywords: 'DZent,about us,company vision,mission,team,Hong Kong tech company',
    },
  },
  '/products': {
    'zh-TW': {
      title: '旗艦平台 | 埵智有限公司 DZent Limited',
      description: '探索埵智的兩大企業級合約風控引擎：建築合約風險掃描 Vowpace AI 與信用證單據預審 LC Shield。',
      keywords: '埵智,DZent,Vowpace AI,LC Shield,合約風險,信用證審核,建築科技',
    },
    'zh-CN': {
      title: '旗舰平台 | 埵智有限公司 DZent Limited',
      description: '探索埵智的两大企业级合同风控引擎：建筑合同风险扫描 Vowpace AI 与信用证单据预审 LC Shield。',
      keywords: '埵智,DZent,Vowpace AI,LC Shield,合同风险,信用证审核,建筑科技',
    },
    en: {
      title: 'Flagship Platforms | DZent Limited',
      description: 'Explore DZent\'s two enterprise contract-risk engines: Vowpace AI for construction contract risk scanning and LC Shield for letter-of-credit document pre-audits.',
      keywords: 'DZent,Vowpace AI,LC Shield,contract risk,LC audit,construction tech',
    },
  },
  '/products/vowpace': {
    'zh-TW': {
      title: 'Vowpace AI | 簽約前分包合約條款風險審查 | 埵智有限公司',
      description: 'Vowpace AI 是專為美國商業分包商而設的簽約前分包合約條款風險審查工具。自動標記隱藏的違約賠償金、概括性彌償與有條件付款（pay-when-paid）條款。',
      keywords: 'Vowpace,Vowpace AI,建築合約,合約風險,分包合約,違約賠償金,彌償條款,埵智,DZent',
    },
    'zh-CN': {
      title: 'Vowpace AI | 签约前分包合同条款风险审查 | 埵智有限公司',
      description: 'Vowpace AI 是专为美国商业分包商而设的签约前分包合同条款风险审查工具。自动标记隐藏的违约赔偿金、概括性弥偿与有条件付款（pay-when-paid）条款。',
      keywords: 'Vowpace,Vowpace AI,建筑合同,合同风险,分包合同,违约赔偿金,弥偿条款,埵智,DZent',
    },
    en: {
      title: 'Vowpace AI | Pre-signature Subcontract Clause-Risk Review | DZent Limited',
      description: 'Vowpace AI is a pre-signature subcontract clause-risk review tool for US commercial subcontractors. Flags hidden liquidated damages, broad-form indemnities, and pay-when-paid clauses.',
      keywords: 'Vowpace,Vowpace AI,construction contract,contract risk scanner,liquidated damages,indemnity,DZent',
    },
  },
  '/products/lc-shield': {
    'zh-TW': {
      title: 'LC Shield | AI 驅動的 UCP 600 與 MT700 單據瑕疵審核助手 | 埵智有限公司',
      description: 'LC Shield：在交單予銀行之前，依 UCP 600 與 ISBP 821 (2023) 預先核對您的信用證交單文件 — 通常 30 秒內完成，助您及早發現可能的瑕疵。',
      keywords: 'LC Shield,UCP 600,MT700,ISBP 821 (2023),信用證,貿易單據,單據瑕疵,出口商,埵智,DZent',
    },
    'zh-CN': {
      title: 'LC Shield | AI 驱动的 UCP 600 与 MT700 单据瑕疵审核助手 | 埵智有限公司',
      description: 'LC Shield：在交单予银行之前，依 UCP 600 与 ISBP 821 (2023) 预先核对您的信用证交单文件 — 通常 30 秒内完成，助您及早发现可能的瑕疵。',
      keywords: 'LC Shield,UCP 600,MT700,ISBP 821 (2023),信用证,贸易单据,单据瑕疵,出口商,埵智,DZent',
    },
    en: {
      title: 'LC Shield | AI-Powered UCP 600 & MT700 Discrepancy Assistant | DZent Limited',
      description: "LC Shield: Pre-checks your letter-of-credit presentation against UCP 600 and ISBP 821 (2023) in typically under 30 seconds, so you can catch likely discrepancies before you present to the bank.",
      keywords: 'LC Shield,UCP 600,MT700,ISBP 821 (2023),letter of credit,trade documents,discrepancy,exporters,DZent',
    },
  },
  '/contact': {
    'zh-TW': {
      title: '聯繫我們 | 埵智有限公司 DZent Limited',
      description: '有任何問題或合作意向？歡迎隨時與埵智有限公司聯繫。公司郵箱：info@dzentlimited.com',
      keywords: '埵智,DZent,聯繫,合作,商務洽談,info@dzentlimited.com',
    },
    'zh-CN': {
      title: '联系我们 | 埵智有限公司 DZent Limited',
      description: '有任何问题或合作意向？欢迎随时与埵智有限公司联系。公司邮箱：info@dzentlimited.com',
      keywords: '埵智,DZent,联系,合作,商务洽谈,info@dzentlimited.com',
    },
    en: {
      title: 'Contact Us | DZent Limited',
      description: 'Have questions or partnership inquiries? Feel free to reach out to DZent Limited. Email: info@dzentlimited.com',
      keywords: 'DZent,contact,partnership,business inquiry,info@dzentlimited.com',
    },
  },
  '/insights': {
    'zh-TW': {
      title: '技術洞察 | 埵智有限公司 DZent Limited',
      description: '從貿易金融合規、建築合約風險到私隱優先架構 — DZent 把打造兩款 AI 產品的工程思考，寫成深度技術筆記。',
      keywords: '技術洞察,AI,UCP 600,私隱優先,建築合約,貿易金融,埵智,DZent',
    },
    'zh-CN': {
      title: '技术洞察 | 埵智有限公司 DZent Limited',
      description: '从贸易金融合规、建筑合同风险到隐私优先架构 — DZent 把打造两款 AI 产品的工程思考，写成深度技术笔记。',
      keywords: '技术洞察,AI,UCP 600,隐私优先,建筑合同,贸易金融,埵智,DZent',
    },
    en: {
      title: 'Tech Insights | DZent Limited',
      description: 'From trade finance compliance and construction contract risk to privacy-first architecture — deep engineering notes from building two AI products.',
      keywords: 'tech insights,AI,UCP 600,privacy-first,construction contracts,trade finance,DZent',
    },
  },
  '/insights/ucp-600': {
    'zh-TW': {
      title: 'AI 如何依 UCP 600 預先核對信用證單據，及早發現瑕疵 | 埵智有限公司',
      description: '自動化單據解析如何幫助出口商在交單前發現可能的瑕疵，從而避免部分拒付後隨之而來的銀行費用與延誤。',
      keywords: 'UCP 600,ISBP 821 (2023),MT700,信用證,單據瑕疵,AI 審單,貿易金融,LC Shield,埵智,DZent',
    },
    'zh-CN': {
      title: 'AI 如何依 UCP 600 预先核对信用证单据，及早发现瑕疵 | 埵智有限公司',
      description: '自动化单据解析如何帮助出口商在交单前发现可能的瑕疵，从而避免部分拒付后随之而来的银行费用与延误。',
      keywords: 'UCP 600,ISBP 821 (2023),MT700,信用证,单据瑕疵,AI 审单,贸易金融,LC Shield,埵智,DZent',
    },
    en: {
      title: 'How AI Pre-Checks LC Documents Against UCP 600 to Catch Discrepancies Earlier | DZent Limited',
      description: 'How automated document parsing helps exporters spot likely discrepancies before presenting, and avoid some of the bank fees and delays that follow a refusal.',
      keywords: 'UCP 600,ISBP 821 (2023),MT700,letter of credit,discrepancy,AI document checking,trade finance,LC Shield,DZent',
    },
  },
  '/insights/zero-storage': {
    'zh-TW': {
      title: '私隱優先架構：企業 AI 時代的設計哲學 | 埵智有限公司',
      description: '當最敏感的合約與貿易單據交給 AI 處理，「分析後不儲存於伺服器」為何是企業最在意的安全承諾。深入了解私隱優先架構如何運作。',
      keywords: '私隱優先,記憶體內處理,企業 AI,私隱架構,資料安全,合規,埵智,DZent',
    },
    'zh-CN': {
      title: '隐私优先架构：企业 AI 时代的设计哲学 | 埵智有限公司',
      description: '当最敏感的合同与贸易单据交给 AI 处理，「分析后不存储于服务器」为何是企业最在意的安全承诺。深入了解隐私优先架构如何运作。',
      keywords: '隐私优先,内存内处理,企业 AI,隐私架构,数据安全,合规,埵智,DZent',
    },
    en: {
      title: 'Privacy-First Architecture: A Design Philosophy for the Enterprise AI Era | DZent Limited',
      description: 'When your most sensitive contracts and trade documents meet AI, why "not saved to our servers after analysis" is the promise enterprises care about most. A deep dive into privacy-first architecture.',
      keywords: 'privacy-first,in-memory processing,enterprise AI,privacy architecture,data security,compliance,DZent',
    },
  },
  '/insights/construction-ai': {
    'zh-TW': {
      title: 'AI 如何在簽約前審查美國分包合約的條款風險 | 埵智有限公司',
      description: '拆解 AI 如何解析分包合約，標記違約賠償金、彌償與付款條件等高風險條款。',
      keywords: '分包合約,AI 合約掃描,風險條款,簽約前審查,Vowpace AI,建築科技,埵智,DZent',
    },
    'zh-CN': {
      title: 'AI 如何在签约前审查美国分包合同的条款风险 | 埵智有限公司',
      description: '拆解 AI 如何解析分包合同，标记违约赔偿金、弥偿与付款条件等高风险条款。',
      keywords: '分包合同,AI 合同扫描,风险条款,签约前审查,Vowpace AI,建筑科技,埵智,DZent',
    },
    en: {
      title: 'How AI Reviews US Subcontract Clause Risk Before You Sign | DZent Limited',
      description: 'How AI parses subcontracts and flags high-risk clauses — liquidated damages, indemnities, and payment conditions.',
      keywords: 'US subcontracts,AI contract scanning,risk clauses,pre-signature review,Vowpace AI,ConTech,DZent',
    },
  },
  '/privacy': {
    'zh-TW': {
      title: '私隱政策 | 埵智有限公司 DZent Limited',
      description: '埵智有限公司（DZent Limited）的私隱政策。了解我們如何收集、使用及保護您的個人資料。',
      keywords: '埵智,DZent,私隱政策,個人資料,Privacy Policy',
    },
    'zh-CN': {
      title: '隐私政策 | 埵智有限公司 DZent Limited',
      description: '埵智有限公司（DZent Limited）的隐私政策。了解我们如何收集、使用及保护您的个人资料。',
      keywords: '埵智,DZent,隐私政策,个人资料,Privacy Policy',
    },
    en: {
      title: 'Privacy Policy | DZent Limited',
      description: 'Privacy Policy of DZent Limited. Learn how we collect, use, and protect your personal data.',
      keywords: 'DZent,privacy policy,personal data,Hong Kong',
    },
  },
  '/terms': {
    'zh-TW': {
      title: '服務條款 | 埵智有限公司 DZent Limited',
      description: '埵智有限公司（DZent Limited）官方網站的服務條款，包括網站使用規則、知識產權及免責聲明。',
      keywords: '埵智,DZent,服務條款,使用條款,Terms of Service',
    },
    'zh-CN': {
      title: '服务条款 | 埵智有限公司 DZent Limited',
      description: '埵智有限公司（DZent Limited）官方网站的服务条款，包括网站使用规则、知识产权及免责声明。',
      keywords: '埵智,DZent,服务条款,使用条款,Terms of Service',
    },
    en: {
      title: 'Terms of Service | DZent Limited',
      description: 'Terms of Service for the official website of DZent Limited, covering website usage, intellectual property, and disclaimers.',
      keywords: 'DZent,terms of service,terms of use,Hong Kong',
    },
  },
};
const getOrganizationSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'DZent Limited',
  alternateName: '埵智有限公司',
  url: SITE_URL,
  email: 'info@dzentlimited.com',
  description: 'DZent Limited is a Hong Kong company that develops and operates AI software for contract and trade-document risk checking, including LC Shield and Vowpace AI.',
  logo: { '@type': 'ImageObject', url: `${SITE_URL}/logo.png` },
  foundingLocation: { '@type': 'Place', name: 'Hong Kong' },
  sameAs: [],
});

const ARTICLE_DATES = {
  '/insights/ucp-600': '2026-08-01',
  '/insights/zero-storage': '2026-07-01',
  '/insights/construction-ai': '2026-06-01',
};

const getArticleSchema = (lang, path) => ({
  '@context': 'https://schema.org',
  '@type': 'Article',
  headline: seoData[path]?.[lang]?.title || '',
  description: seoData[path]?.[lang]?.description || '',
  author: { '@type': 'Organization', name: 'DZent Limited' },
  publisher: {
    '@type': 'Organization',
    name: 'DZent Limited',
    logo: { '@type': 'ImageObject', url: `${SITE_URL}/logo.png` },
  },
  datePublished: ARTICLE_DATES[path] || '2026-08-01',
  dateModified: ARTICLE_DATES[path] || '2026-08-01',
  mainEntityOfPage: { '@type': 'WebPage', '@id': `${SITE_URL}${path}` },
});

// Language mappings
const langToHreflang = {
  'zh-TW': 'zh-Hant',
  'zh-CN': 'zh-Hans',
  en: 'en',
};
const OG_LOCALES = { 'zh-TW': 'zh_TW', 'zh-CN': 'zh_CN', en: 'en_US' };

// DOM helpers (module-level, stable across renders)
const setMeta = (name, content) => {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const setOG = (property, content) => {
  let el = document.querySelector(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('property', property);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const setCanonical = (href) => {
  let canonical = document.querySelector('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement('link');
    canonical.setAttribute('rel', 'canonical');
    document.head.appendChild(canonical);
  }
  canonical.setAttribute('href', href);
};

const addAlternateLink = (hreflang, href) => {
  const link = document.createElement('link');
  link.setAttribute('rel', 'alternate');
  link.setAttribute('hreflang', hreflang);
  link.setAttribute('href', href);
  document.head.appendChild(link);
};

const applyHreflangTags = (path) => {
  document.querySelectorAll('link[rel="alternate"][hreflang]').forEach((el) => el.remove());
  Object.entries(langToHreflang).forEach(([langCode, hreflang]) => {
    addAlternateLink(hreflang, `${SITE_URL}${path}?lang=${langCode}`);
  });
  addAlternateLink('x-default', `${SITE_URL}${path}`);
};

const addJsonLd = (key, schema) => {
  const script = document.createElement('script');
  script.setAttribute('type', 'application/ld+json');
  script.setAttribute('data-seo-jsonld', key);
  script.textContent = JSON.stringify(schema);
  document.head.appendChild(script);
};

const applyJsonLd = (path, lang) => {
  document.querySelectorAll('script[data-seo-jsonld]').forEach((el) => el.remove());
  addJsonLd('organization', getOrganizationSchema());
  if (path.startsWith('/insights/')) addJsonLd('article', getArticleSchema(lang, path));
};

const applyOpenGraph = (path, lang, data) => {
  setOG('og:title', data.title);
  setOG('og:description', data.description);
  setOG('og:type', path.startsWith('/insights/') ? 'article' : 'website');
  setOG('og:url', `${SITE_URL}${path}`);
  setOG('og:locale', OG_LOCALES[lang] || 'en_US');
  setOG('og:site_name', 'DZent Limited');
};

const removeSeoTags = () => {
  document.querySelectorAll('link[rel="alternate"][hreflang]').forEach((el) => el.remove());
  document.querySelectorAll('script[data-seo-jsonld]').forEach((el) => el.remove());
};

export default function SEOHead({ path }) {
  const { lang } = useLanguage();

  useEffect(() => {
    const data = seoData[path]?.[lang] || seoData['/'][lang];
    if (!data) return undefined;

    document.title = data.title;
    setMeta('description', data.description);
    setMeta('keywords', data.keywords);
    applyOpenGraph(path, lang, data);
    setCanonical(`${SITE_URL}${path}`);
    applyHreflangTags(path);
    applyJsonLd(path, lang);
    document.documentElement.lang = langToHreflang[lang] || 'en';

    return removeSeoTags;
  }, [path, lang]);

  return null;
}
